import { Injectable } from '@angular/core';

import { TextDocument } from '../../models/text-document';

import { BackendBaseService } from '../backend-base.service';
import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root',
})
export class TextDocumentService extends BackendBaseService {
  /**
   * URL for client intakes controller
   * @type {String}
   */
  url = 'text_documents';

  /**
   * Constructor
   * @param {HttpClientService} private httpClient Service for making HTTP requests with different methods
   */
  constructor(public httpClient: HttpClientService) {
    super(httpClient);
  }

  preview(textContent: string, involvementId: number, matterId: number | null = null): Promise<any> {
    return this.httpClient.post(`${this.url}/preview.json`, {
      involvement_id: involvementId,
      matter_id: matterId,
      text_content: textContent,
    });
  }

  /**
   * CREATE and UPDATE actions for Text Document resource
   * @param  {TextDocument} phone_number Text Document to be saved
   * @return {Promise<any>} Save response
   */
  save(textDocument: TextDocument): Promise<any> {
    return super.save({
      text_document: textDocument,
      id: textDocument.id
    });
  }

  /**
   * Send text to selected recipients
   *
   * @param   {any}           params  Recipients and text
   *
   * @return  {Promise<any>}          Server response
   */
  sendText(params: any): Promise<any> {
    return this.create(params);
  }

  reply(textDocumentId: number, textContent: string): Promise<any> {
    return this.httpClient.post(`${this.url}/${textDocumentId}/reply.json`, {
      text_document: {
        text_content: textContent,
      },
    });
  }
}
